import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import logoWhite from "../components/img/logo-white.svg";
import { loginFES } from "../components/utils/JWTAuth";
import ReactGA from "react-ga";
import queryString from "query-string";
import { withRouter } from "react-router-dom";
import Cookies from "js-cookie";

class Login extends React.Component {
  state = {
    email: "",
    password: "",
    emailUrl: "",
    url: "",
    error: null,
    isLoading: false
  };

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      error: null
    });
  };

  componentDidMount() {
    const values = queryString.parse(window.location.search);
    window.scrollTo(0, 0);

    if (values.fromAdmin) {
      Cookies.set("fromAdmin", "1", { 
        expires: 1,
        secure: true,
        sameSite: 'Strict'
      });
    }

    if (values.email) {
      this.setState({
        email: values.email,
        emailUrl: values.email,
      });
    }

    if (this.props.history.location.state?.url_permalink) {
      this.setState({
        url: this.props.history.location.state.url_permalink,
      });
    }

    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password, url } = this.state;
    
    // Basic validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      this.setState({
        error: "El email introducido no es válido. Debe contener una @ y un dominio válido."
      });
      return;
    }

    this.setState({ isLoading: true, error: null });

    try {
      const formData = new FormData();
      formData.append('email', email);
      formData.append('passw', password);
      await loginFES(formData, email);
    } catch (error) {
      this.setState({ isLoading: false });

      // Verificar si el error tiene una respuesta con código de estado
      if (error.response) {
        if (error.response.status === 401) {
          // Mostrar un mensaje personalizado para credenciales incorrectas
          this.setState({
            error: "Credenciales incorrectas. Por favor, inténtalo de nuevo."
          });
        } else {
          // Si es otro error (por ejemplo, servidor caído)
          this.setState({
            error: error.response.data?.message || "Ha ocurrido un error en el servidor."
          });
        }
      } else {
        // Si no hay respuesta (error de red, por ejemplo)
        this.setState({
          error: "No se pudo conectar al servidor. Inténtalo más tarde."
        });
      }
    }
  };

  render() {
    const { email, password, emailUrl, isLoading, error } = this.state;
    const isEnabled = email.length > 0 && password.length > 0;

    return (
      <div>
        <hr className="whiteSpace"></hr>
        <Container className="width-100 nopadding maxWidth-100">
          <Row>
            <Col md={5} sm={12}>
              <div className="align-items-center h-sm-100-vh d-flex bg-grad-blue">
                <div className="width-100 textWhite login-padding">
                  <img src={logoWhite} alt="Fes login logo" width="230px" />
                  <h2 className="textWhite">Te damos la bienvenida a FES</h2>
                  <div hidden>
                    <h2 className="textWhite">
                      Aviso para usuarios registrados en la antigua web
                    </h2>
                    <div className="listCheck textWhite">
                      <p className="textWhite">Estimado/a amigo/a,</p>
                      <p className="textWhite">
                        En nuestro proceso de mejora, hemos actualizado nuestra
                        web y necesitamos que actualices tu contraseña.
                      </p>
                      <p className="textWhite">
                        Si ya entrabas en nuestra antigua web, utiliza la cuenta
                        de email que utilizabas y pulsa sobre la opción
                        "Recordar contraseña", te llegará un email con un enlace
                        donde podrás poner tu password nueva.
                      </p>
                      <p className="textWhite">
                        Una vez cambiada la contraseña, utiliza tu email y tu
                        nueva contraseña para loguearte y acceder a tus datos.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={7} sm={12}>
              <div className="align-items-center h-sm-100-vh d-flex mx-auto form-login">
                <div className="width-100 login-padding">
                  <h2>Inicia sesión</h2>
                  {error && (
                    <div className="alert alert-danger">
                      {error}
                    </div>
                  )}
                  <div className="listCheck">
                    <Form onSubmit={this.handleSubmit}>
                      <Form.Group controlId="email">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="E-mail"
                          name="email"
                          defaultValue={email || emailUrl}
                          onChange={this.handleInputChange}
                          required
                        />
                      </Form.Group>
                      <Form.Group controlId="password">
                        <Form.Label>Contraseña</Form.Label>
                        <Form.Control
                          type="password"
                          placeholder="Contraseña"
                          name="password"
                          value={password}
                          onChange={this.handleInputChange}
                          required
                        />
                      </Form.Group>
                      <p>
                        ¿No tienes una cuenta?{" "}
                        <a href="/registro">Registrarse ahora</a>
                        <br />
                        ¿Has olvidado la contraseña?{" "}
                        <a href="/recordar-password">Recordar Contraseña</a>
                      </p>
                      <Button
                        variant="primary"
                        className="Acceder"
                        type="submit"
                        disabled={!isEnabled || isLoading}
                      >
                        {isLoading ? 'Iniciando sesión...' : 'Entrar'}
                      </Button>
                    </Form>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
export default withRouter(Login);